import axiosClient from "../axios/axiosClient";

export function getAdmins() {
  return axiosClient.get("/admins");
}

export function getAdmin(adminID) {
  return axiosClient.get(`/admins/${adminID}`);
}

export function getAdminByUserId(userID) {
  return axiosClient.get(`/admin-by-user/${userID}`);
}

export const createAdmin = (data) => {
  return axiosClient.post("/admins", data);
};

export const updateAdmin = (adminID, data) => {
  return axiosClient.put(`/admins/${adminID}`, data);
};

export function deleteAdmin(adminID) {
  return axiosClient.delete(`/admins/${adminID}`);
}

export const resetAdminPassword = (adminID, data) => {
  return axiosClient.patch(`/reset-admin-password/admin/${adminID}`, data);
};

export const attachAdminToInstitution = (adminID, data) => {
  return axiosClient.patch(
    `/attach-admin-to-institution/admin/${adminID}`,
    data
  );
};

export const dettachAdminFromInstitution = (adminID) => {
  return axiosClient.patch(`/dettach-admin-from-institution/admin/${adminID}`);
};
